import { FC } from "react";
import { SubscriptionsView } from "../../../../../../../../../../modules/preferences/views/billing-preferences-view/subviews/subscriptions-view/subscriptions-view";
import { useParams } from "react-router-dom";

export const SubscriptionsRoute: FC = () => {

    // router hooks
    const {
        organization_id: organizationId,
    } = useParams() as {
        organization_id: string
    }

    return (
        <SubscriptionsView
            organizationId={organizationId}
        />
    )
}